// extracted by mini-css-extract-plugin
export default {"renameIcon":"TagsModalContent-renameIcon-G0MYo","message":"TagsModalContent-message-ITZMV","result":"TagsModalContent-result-xdDkN"};